import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { AppIcon, AppText, Avatar, Box, Column, styled, useTheme } from '@streem/ui-react';
import { recordScreenViewed } from '@streem/analytics';
import { useObservable } from '../../..';
import { CameraSubject } from 'streem-sdk-protobuf';
import { map } from 'rxjs/operators';
export function CameraInactiveScreen({ videoController, mobileDisplay, determinedUIProperties, constrainContainerToCanvas, aspectRatioConversion, }) {
    const theme = useTheme();
    const [connected] = useObservable(videoController.connected);
    const [enabled] = useObservable(videoController.muted.pipe(map(muted => !muted)));
    const [backgrounded] = useObservable(videoController.backgrounded);
    const [paused] = useObservable(videoController.paused);
    const [cameraSubject] = useObservable(videoController.cameraSubject);
    const inPip = determinedUIProperties?.switches.inPip ?? false;
    useEffect(() => {
        if (paused) {
            const pauseMessageScreenId = `call: ${mobileDisplay ? 'host' : 'spectator'} remote participant video paused`;
            // This component displays multiple messages but for analytics purposes,
            // we only want to record the view when chime has paused the remote video
            recordScreenViewed(pauseMessageScreenId);
        }
    }, [paused, mobileDisplay]);
    if (!connected ||
        (enabled && !backgrounded && !paused) ||
        (inPip && videoController.ownerIsLocalUser && !mobileDisplay)) {
        return _jsx(_Fragment, {});
    }
    return (_jsxs(Container, { mobileDisplay: mobileDisplay, inPip: inPip, enabled: enabled && !backgrounded, worldFacingMobileDisplayCameraOff: videoController.ownerIsLocalUser &&
            mobileDisplay &&
            inPip &&
            cameraSubject === CameraSubject.CAMERA_SUBJECT_WORLD, constrainContainerToCanvas: constrainContainerToCanvas, aspectRatioConversion: aspectRatioConversion, isFullScreenDesktop: !videoController.ownerIsLocalUser &&
            !mobileDisplay &&
            cameraSubject === CameraSubject.CAMERA_SUBJECT_WORLD, children: [!paused &&
                (determinedUIProperties?.switches.showAvatar ? (_jsx(Avatar, { src: determinedUIProperties?.properties.avatarSrc, displayName: determinedUIProperties.properties.displayName, size: determinedUIProperties.switches.inPip ? 'small' : 'xlarge', "data-clarity-mask": "true" })) : (_jsx(AppIcon, { name: determinedUIProperties?.properties.icon ?? 'CameraOffIcon', color: theme.colors.grey30, size: determinedUIProperties?.properties.message ? 'large' : 'medium', "data-clarity-mask": "true" }))), determinedUIProperties?.properties.message && (_jsx(MessageContainer, { paused: paused || false, mobileDisplay: mobileDisplay, inPip: inPip, children: _jsx(MessageText, { as: "p", size: 'medium', paused: paused || false, mobileDisplay: mobileDisplay, inPip: inPip, determinedUIProperties: determinedUIProperties, children: determinedUIProperties?.properties.message ?? '' }) }))] }));
}
const MessageContainer = styled(Box)(({ paused, mobileDisplay, inPip }) => ({
    width: paused && !mobileDisplay ? '335px' : '100%',
    marginTop: paused && mobileDisplay ? '0px' : '16px',
    paddingLeft: paused && inPip ? '0px' : '16px',
    paddingRight: paused && inPip ? '0px' : '16px',
}));
MessageContainer.displayName = 'MessageContainer';
const MessageText = styled(AppText)(({ theme, determinedUIProperties }) => ({
    textAlign: 'center',
    fontSize: determinedUIProperties?.styles.fontSize ?? '1rem',
    color: determinedUIProperties?.styles.fontColor ?? theme.colors.grey40,
}));
const Container = styled(Column)(
// @ts-ignore
({ mobileDisplay, enabled, worldFacingMobileDisplayCameraOff, constrainContainerToCanvas, aspectRatioConversion, inPip, isFullScreenDesktop, theme, }) => {
    const sharedStyles = {
        top: 0,
        position: 'absolute',
        zIndex: 3,
        userSelect: 'none',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: constrainContainerToCanvas
            ? `calc(var(--auto-grid-height) * ${aspectRatioConversion})`
            : '100%',
        backgroundColor: worldFacingMobileDisplayCameraOff ? undefined : theme.colors.grey90,
        border: `${enabled ? 0 : '1px'} solid ${theme.colors.grey80}`,
        color: theme.colors.grey40,
    };
    // if it's on mobile AND in a pip --- grey border + 10px border radius
    if (mobileDisplay && inPip) {
        return {
            borderRadius: '10px',
            ...sharedStyles,
        };
    }
    // if it's on mobile and NOT in a pip -- no border, no border radius
    if (mobileDisplay && !inPip) {
        return {
            ...sharedStyles,
            borderRadius: undefined,
            border: 'none',
        };
    }
    // if it's NOT on mobile -- grey border + 20px border radius, except for when video is world facing in EV2
    return {
        ...sharedStyles,
        borderRadius: isFullScreenDesktop ? '0px' : '20px',
    };
});
//# sourceMappingURL=camera_inactive_screen.js.map